import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function BuildYieldCalculator({ config }) {
  // Calculate yield based on config
  const baseYield = 1240;
  const privacyBonus = config.validation.id === 'handoff' ? 0.15 : config.validation.id === 'doppelganger' ? 0.10 : 0;
  const engineBonus = config.engine.id === 'neuro' ? 0.20 : config.engine.id === 'local-llm' ? 0.10 : 0;
  
  const totalYield = Math.floor(baseYield * (1 + privacyBonus + engineBonus));

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-zinc-900/50 border border-amber-500/30 rounded-lg p-5 box-glow-amber mt-4"
    >
      <div className="flex items-center gap-2 mb-3">
        <SafeIcon icon={FiIcons.FiTrendingUp} className="text-amber-400" />
        <span className="text-[10px] font-mono tracking-widest text-amber-400 uppercase">
          Projected Monthly Yield
        </span>
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-3xl font-black text-amber-400 text-glow-amber font-mono">
          ${totalYield.toLocaleString()}
        </span>
        <span className="text-xs text-zinc-500 font-mono">/month</span>
      </div>
      <div className="mt-3 pt-3 border-t border-zinc-800/50 text-[10px] text-zinc-500 space-y-1">
        <div className="flex justify-between">
          <span>Privacy Tier:</span>
          <span className="text-amber-400">+{Math.round(privacyBonus * 100)}%</span>
        </div>
        <div className="flex justify-between">
          <span>AI Core:</span>
          <span className="text-cyan-400">+{Math.round(engineBonus * 100)}%</span>
        </div>
      </div>
    </motion.div>
  );
}